<template>
<div id="app" class="layout layout-main">
    <Header></Header>
    <div class="orderdetail_main">
        <loading v-if="pageLoading"></loading>
        <div class="order_detaile_content">
            <h2 class="section_title">支付信息</h2>
            <ul class="info_list">
                <li><span class="label">商品总额</span><div class="info_text">{{orderInfo.cost_item}}元</div></li>
                <li><span class="label">配送费用</span><div class="info_text">{{orderInfo.cost_freight}}元</div></li>
                <li><span class="label">订单总额</span><div class="info_text">{{orderInfo.order_total_money}}元</div></li>
                <li><span class="label">支付方式</span><div class="info_text">{{orderInfo.pay_method|payMethod}}</div></li>
                <li><span class="label">应收金额</span><div class="info_text">{{orderInfo.order_total_money}}元</div></li>
                <li><span class="label">优惠金额</span><div class="info_text">{{orderInfo.pmt_amount}}元</div></li>
                <li><span class="label">实收金额</span><div class="info_text" v-html="finalAmount()"></div></li>
                <li><span class="label">补贴供应商金额</span><div class="info_text">{{orderInfo.pmt_amount}}元</div></li>
            </ul>
            <h2 class="section_title">发码信息</h2>
            <ul class="info_list">
                <li v-for="item in verifyInfo.extend_data">
                    <span class="label">{{item.desc}}</span>
                    <div class="info_text">{{item.value}}</div>
                </li>
                <li >
                    <span class="label">消费码</span>
                    <div class="info_text">{{verifyInfo.coupon}}</div>
                </li>
            </ul>
            <h2 class="section_title">备注信息</h2>
            <ul class="info_list">
                <li><span class="label">订单备注</span><div  class="info_text">
                    <p class="info_txt">注：如果支付方式中包含积分支付，则供应商无需向消费者开具发票。</p>
                    </div></li>
                <li>
                    <span class="label">核销备注</span>
                    <div class="remark">
                        {{verifyInfo.remark}}
                    </div>
                </li>
            </ul>
        </div>
        <Button class="w-160 m-t-10" size="large" type="ghost" @click="goback">返回</Button>
    </div>
</div>
</template>
<script>   
    import Header from '@/components/header_verify.vue'
    import {httpGet,httpPost, loginHttpPost} from '@/api/base';
    import loading from '@/components/loading.vue';
    import config from '@/config/config'
    export default {
        data() {
            return {
                shopDomain: config.shop_api_domain,
                pageLoading:true,
                id:'',
                orderInfo:{},
                verifyInfo:{}
            }
        },
        components: {loading,Header},
        mounted() {
            let Vm = this;
            window.V=this;
            this.id=Vm.$route.params.id;
            Vm.getOederDetail();
        },
        computed:{
            
        },
        filters:{
            payMethod(val){
                switch(val){
                    case 1:
                        return '现金+积分'
                        break;
                    case 2:
                        return '现金'
                        break;
                    case 3:
                        return '积分'
                        break;
                    case 4:
                        return '现金'
                        break;
                } 
            }
        },
        methods:{
            goback(){
                window.history.go(-1)
            },
            finalAmount(){
                let orderInfo=this.orderInfo;
                if(orderInfo.pay_method==1){
                    return orderInfo.final_amount+'元'+'&nbsp;&nbsp;'+'<span>( 现金:'+ orderInfo.payed +'元 积分:'+orderInfo.point_amount +'元 )</span>'
                }else{
                    return orderInfo.final_amount+'元'
                }
            },
            getOederDetail(){
                let Vm=this;
                console.log(this.shopDomain,'this.shopDomain')
                loginHttpPost(this.shopDomain+'/Shop/O2OVerify/getVerifyOrderDetail',{id:this.id},function(res){
                    Vm.pageLoading=false;
                    console.log(res)
                    Vm.orderInfo = res.order_detail;
                    Vm.verifyInfo = res.data;
                },function(error){
                    Vm.pageLoading=false;
                    Vm.$Message.error(error)
                })
            }
        }
    }
</script>
<style lang="scss" scope>
@import './asset/css/index.scss';
</style>